// extracted by mini-css-extract-plugin
export default {"root":"IconButton_root__vheSs","active":"IconButton_active__QgDLA","rounded":"IconButton_rounded__CDMKU"};